<template>
  <div class="adsense-wrapper" v-if="consentGranted">
    <!-- Bloque de anuncio -->
    <ins class="adsbygoogle"
         style="display:block"
         data-ad-client="ca-pub-9628295245533169"
         data-ad-slot="1234567890"
         data-ad-format="auto"
         data-full-width-responsive="true"></ins>
  </div>
</template>

<script>
import { watch, nextTick, onMounted } from 'vue';
import { consentGranted } from '../services/consentService';

export default {
  name: "AdSense",
  setup() {
    const initAd = () => {
      nextTick(() => {
        try {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (e) {
          console.log("AdSense initialization error:", e);
        }
      });
    };

    onMounted(() => {
      if (consentGranted.value) {
        initAd();
      } else {
        // Si no está aceptado, esperamos a que cambie a true
        const stopWatch = watch(consentGranted, (newValue) => {
          if (newValue) {
            initAd();
            stopWatch(); // Detener el watch después de inicializar
          }
        });
      }
    });

    return {
      consentGranted
    };
  }
};
</script>

<style scoped>
.adsense-wrapper {
  margin: 1.5rem auto;
  text-align: center;
  width: 100%;
  display: block;
  min-height: 100px; /* Evita colapsar completamente el diseño si se carga */
}
</style>
